import lk from '@/api/services/lk'
import idp from '@/api/services/idp'
import report from '@/api/services/report'
import dadata from '@/api/services/dadata'
import account from '@/api/services/account'
import webrestore from '@/api/services/webrestore'

export default { lk, idp, report, dadata, webrestore, account }
